// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"7eb85efe","232":"0dae3abf","237":"a9af2573","357":"641eb3ba","526":"fb6909a2","787":"fa3903d5","872":"9251c48f"}[chunkId] + ".chunk.js";
};